module.exports = __webpack_public_path__ + "img/upload_proposal.ed347ad5.svg";